/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { Button, Modal, CloseButton } from "react-bootstrap";
import "./WnbModalAlert.css";

const WnbModal = (props) => {
  let showAlert = props.showAlert;
  const onClickModalNo = props.handleCancel;
  const onClickModalYes = props.handleYes;
  const title = props.title;
  const message = props.message;
  const yesLabel = props.yesLabel || "Yes";
  const noLabel = props.noLabel || "No";

  return (
    <Modal
      show={showAlert}
      onHide={onClickModalNo}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <CloseButton aria-label="Close" onClick={onClickModalNo}/>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="wnbmodal-btn" onClick={onClickModalYes}>
          {yesLabel}
        </Button>
        <Button variant="secondary" className="wnbmodal-btn" onClick={onClickModalNo}>
          {noLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WnbModal;
